import { procedureIdSchema } from "@assetwatch/procedure-contract";
import { z } from "zod";
import { workApiFetch } from "./workClient";

const responseSchema = z.object({
  defaultProcedureId: procedureIdSchema.nullable(),
});

export async function saveDefaultProcedure(input: {
  param: { customerId: string; facilityId: string };
  json: { procedureId: string | null };
}) {
  const response = await workApiFetch(
    `/v1/customers/${encodeURIComponent(input.param.customerId)}/facilities/${encodeURIComponent(input.param.facilityId)}/procedures/default`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(input.json),
    },
  );
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    const message =
      body && typeof body === "object" && "error" in body
        ? String(body.error)
        : "Unable to update the default Procedure.";
    throw new Error(message);
  }
  return responseSchema.parse(await response.json());
}
